var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.weightList,"fields":_vm.fields},scopedSlots:_vm._u([{key:"delete",fn:function(row){return [_c('b-button',{attrs:{"size":"xs","variant":"danger"},on:{"click":function($event){_vm.deleteWeight(row.item.date)}}},[_vm._v("Delete")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8006f5a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeightList.vue
// module id = 229
// module chunks = 1